"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var react_intl_1 = require("react-intl");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    endMessage: {
        padding: theme.spacing(6) + "px 0",
    },
}); });
var EndMessage = react_1.memo(function (props) {
    var hasNotifications = props.hasNotifications;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Typography, { align: "center", variant: "body2", className: classes.endMessage + " end-message" },
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: hasNotifications ? 'endMessageWithNotifications' : 'endMessageWithoutNotifications' })));
});
exports.default = EndMessage;
